import React from "react";

let Common = React.createContext({
  isMobile: false,
  /** 메뉴 노출용 서비스 플래그 (sessionStorage와 동기화, 변경 시 즉시 리렌더) */
  statistics_service: null,
  simple_statistics_service: null,
  transfer_statistics_service: null,
  annual_pay_service: null,
  board_service: null,
  organization_type: null,
});

export default Common;
